import { Check } from "lucide-react";

/**
 * PATRONES DE CONSTRUCCIÓN VISUAL — vertical sections with full labels.
 * Replaces the cramped 4-column layout that truncated labels in narrow panels.
 */
export default function PatternSelector({ patterns, selected, onToggle }) {
    if (!patterns) return null;
    const entries = Object.entries(patterns);
    return (
        <div
            data-testid="pattern-selector"
            className="rounded-2xl border hairline border-ink-600 bg-ink-900 p-4"
        >
            <div className="flex items-center gap-2 mb-3">
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    className="text-periwinkle-500"
                >
                    <rect x="1" y="1" width="5" height="5" stroke="currentColor" fill="none" />
                    <rect x="8" y="1" width="5" height="5" stroke="currentColor" fill="none" />
                    <rect x="1" y="8" width="5" height="5" stroke="currentColor" fill="none" />
                    <rect x="8" y="8" width="5" height="5" stroke="currentColor" fill="none" />
                </svg>
                <h3 className="font-mono text-[10px] tracking-[0.25em] text-periwinkle-500 uppercase">
                    Patrones de Construcción
                </h3>
                {selected.length > 0 && (
                    <span className="ml-auto font-mono text-[10px] text-fog-400">
                        {selected.length} activo{selected.length === 1 ? "" : "s"}
                    </span>
                )}
            </div>

            <div className="space-y-3">
                {entries.map(([col, items]) => (
                    <div key={col}>
                        <p className="font-mono text-[9px] tracking-[0.25em] text-fog-400 uppercase mb-1.5">
                            {col}
                        </p>
                        <div className="flex flex-wrap gap-1.5">
                            {items.map((p) => {
                                const active = selected.includes(p.id);
                                return (
                                    <button
                                        key={p.id}
                                        type="button"
                                        data-testid={`pattern-${p.id}`}
                                        onClick={() => onToggle(p.id)}
                                        title={p.label}
                                        className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border hairline text-xs transition-all duration-150 ${
                                            active
                                                ? "border-periwinkle-500 text-periwinkle-500 bg-ink-800 shadow-glow-sm"
                                                : "border-ink-600 text-fog-300 hover:text-fog-100 hover:border-fog-500 bg-ink-900/40"
                                        }`}
                                    >
                                        <span className="leading-none">{p.label}</span>
                                        {active && (
                                            <Check className="w-3 h-3" strokeWidth={3} />
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>

            {selected.length > 0 && (
                <button
                    type="button"
                    data-testid="pattern-clear-btn"
                    onClick={() => selected.forEach((id) => onToggle(id))}
                    className="mt-3 w-full text-[10px] font-mono uppercase tracking-widest text-fog-400 hover:text-periwinkle-500 transition-colors py-1.5 border-t hairline border-ink-600 pt-3"
                >
                    Limpiar selección
                </button>
            )}
        </div>
    );
}
